<form (ngSubmit)="ngSubmit()" [formGroup]="formData" class="my-3">
  <div class="baseMainFields">
    <div class="mainFields d-flex flex-wrap">
      <!--Name-->
      <div class="col-5">
        <label class="tagReq">Your Name</label>
        <input placeholder="Type Your Name" formControlName="name" />
        <div
          class="mt-2"
          *ngIf="submit && form.name.errors"
          style="font-size: 80%; color: rgb(244 106 106)">
          <span *ngIf="form.name.errors.required"
            >Please provide a valid name.</span
          >
        </div>
      </div>

      <!--Email-->
      <div class="col-lg-5 ms-lg-5">
        <label class="tagReq">Your Email</label>
        <input placeholder="Type Your Email@" formControlName="email" />
        <div
          class="mt-2"
          *ngIf="submit && form.email.errors"
          style="font-size: 80%; color: rgb(244 106 106)">
          <span *ngIf="form.email.errors.required"
            >This value is required.</span
          >
          <span *ngIf="form.email.errors.pattern"
            >This value should be a valid email.</span
          >
        </div>
      </div>

      <!--Community-->
      <div class="mt-5 col-6">
        <label class="tagReq">What community are you with ?</label>
        <ng-select
          [loading]="!communities"
          [readonly]="created"
          formControlName="community"
          placeholder="Type or select an option">
          <ng-option
            *ngFor="let community of communities"
            [value]="community.id">
            <div>
              {{ community.name }}
            </div>
          </ng-option>
        </ng-select>
        <div
          class="mt-2"
          *ngIf="submit && form.community.errors"
          style="font-size: 80%; color: rgb(244 106 106)">
          <span *ngIf="form.community.errors.required"
            >Please provide a valid community.</span
          >
        </div>
      </div>
    </div>
  </div>
</form>
